module.exports = __webpack_public_path__ + "media/images/emblems/Ballwil_LU-22cef044cb2e40b8c44a05c0273c178b.png";